module.exports = __webpack_public_path__ + "img/cctvinspection_parked.855a93e0.svg";